import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import {
  RankingByScope,
  RankingType,
} from 'src/app/gamification/services/models/ranking.model';
import { ConfigService } from 'src/app/services/config.service';
import { UserService } from 'src/app/services/user.service';
import { GamificationService } from '../../services/gamification.service';
import { RankingScope } from 'src/app/models/client-configuration';
import { LoggerService } from 'src/app/services/logger.service';
import { InfoDialogFacade } from 'src/app/_core/state/dialogs/info/info.facade';

@Component({
  selector: 'app-gamification-ranking',
  templateUrl: './gamification-ranking.component.html',
  styleUrls: ['./gamification-ranking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GamificationMonthlyRankingComponent implements OnInit {

  @Input() ranking: RankingByScope;
  @Input() rankingType: RankingType;

  private readonly gamificationService = inject(GamificationService);
  private readonly configService = inject(ConfigService);
  private readonly userService = inject(UserService);
  private readonly logger = inject(LoggerService);
  private readonly infoDialogFacade = inject(InfoDialogFacade);

  readonly rankingByScope = computed(() => this.ranking[this.getRankingScope(this.ranking)]);
  readonly userRankingSlot = computed(() => this.rankingByScope().slots.find((slot) => slot.user === this.userService.getUserId()));
  readonly description = computed(() => this.getDescription(this.rankingType));
  readonly title = computed(() => this.rankingType === RankingType.MONTHLY ? 'user.ranking.monthly.title' : 'user.ranking.general.title');
  readonly today = computed(() => this.rankingType === RankingType.MONTHLY ? new Date() : null);
  readonly gamificationInfoDialog = computed(() => this.gamificationService.getGamificationInfoDialogData());

  readonly isRankingDialogOpened = signal<boolean>(false);
  readonly isScoreDialogOpened = signal<boolean>(false);

  ngOnInit(): void {
    this.openGeneralRankingIfNoScore();
  }

  openInfoDialog(event: Event) {
    event.preventDefault();
    this.infoDialogFacade.openDialog(this.gamificationInfoDialog().title, this.gamificationInfoDialog().intro, this.gamificationInfoDialog().items);
  }

  private openGeneralRankingIfNoScore() {
    if (this.rankingType === RankingType.GENERAL
      && this.userRankingSlot().score === 0 &&
      (this.configService.get().gmfConfig.showRanking || this.configService.get().gmfConfig.showPoints)
    ) {
      this.infoDialogFacade.openDialog(this.gamificationInfoDialog().title, this.gamificationInfoDialog().intro, this.gamificationInfoDialog().items);
    }
  }

  private getDescription(type: RankingType): string {
    if (!this.configService.get().gmfConfig.showRanking && this.configService.get().gmfConfig.showPoints) {
      return type === RankingType.MONTHLY
        ? 'user.ranking.monthly.description.onlyPoints'
        : 'user.ranking.general.description.onlyPoints';
    }
    return type === RankingType.MONTHLY
      ? 'user.ranking.monthly.description.default'
      : 'user.ranking.general.description.default';
  }

  private getRankingScope(rankingByScope: RankingByScope): RankingScope {
    const label =
      'rankingScope is set to center, however, ranking by center data is coming null. Check OTK logs for more info. Defaulting to platform...';
    const rankingScope = this.configService.get().gmfConfig.rankingScope;

    if (rankingScope === RankingScope.CENTER && rankingByScope.center === null) {
      this.logger.warn(label);
      return RankingScope.PLATFORM;
    }
    return rankingScope;
  }
}
